module.exports = __webpack_public_path__ + "media/images/homepage/background-noise-e2b84be4462098f4e06e21798eaee712.png";